"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ControlsFormDateTimePicker = void 0;
const DOM_1 = require("../../../../../public/js/utils/DOM");
const flatpickr_1 = require("flatpickr");
const cs_js_1 = require("flatpickr/dist/l10n/cs.js");
var ControlsFormDateTimePicker;
(function (ControlsFormDateTimePicker) {
    class Config {
        static inputContainerClass = "DateTimePicker";
        static minDataName = "min";
        static maxDataName = "max";
        static timeEnabledDataName = "timeEnabled";
        static closeButtonElementClass = "DateTimePicker-clear";
        static inputElementClassName = "DateTimePicker-input";
        static inputGeneratedClass = "DateTimePicker-generated";
    }
    class Control {
        static initialize(container) {
            const inputs = DOM_1.DOM.Parser.getHtmlElements(Config.inputContainerClass, container, true);
            for (let i = 0; i < inputs.length; i++) {
                this.initializeElement(inputs[i]);
            }
        }
        static initializeElement(element) {
            const input = DOM_1.DOM.Parser.getHtmlElementByClass(Config.inputElementClassName, element);
            const defaultValue = input.value && input.value.trim().length > 0 ? (parseInt(input.value.trim()) * 1000) : undefined;
            const timeEnabled = DOM_1.DOM.Parser.getDataByNameFromElement(Config.timeEnabledDataName, element) === 'yes';
            let options = {
                disableMobile: true,
                dateFormat: timeEnabled ? 'd-m-Y H:i:S' : 'd-m-Y',
                altFormat: timeEnabled ? 'j. n. Y H:i:S' : 'j. n. Y',
                altInput: true,
                altInputClass: Config.inputGeneratedClass,
                enableTime: timeEnabled,
                enableSeconds: timeEnabled,
                time_24hr: timeEnabled,
                defaultDate: defaultValue,
                locale: DOM_1.DOM.Parser.getLocale() === 'cs' ? cs_js_1.Czech : undefined,
                allowInput: true
            };
            const minDate = DOM_1.DOM.Parser.getDataByNameFromElementOrNull(Config.minDataName, element);
            if (minDate) {
                let minDateObject = new Date(parseInt(minDate) * 1000).getTime();
                options.minDate = (defaultValue && defaultValue < minDateObject) ? defaultValue : minDateObject;
            }
            const maxDate = DOM_1.DOM.Parser.getDataByNameFromElementOrNull(Config.maxDataName, element);
            if (maxDate) {
                options.maxDate = new Date(parseInt(maxDate) * 1000).getTime();
            }
            const flatpickrInstance = (0, flatpickr_1.default)(input, options);
            this.triggerClear(element, flatpickrInstance, input);
            this.triggerLabel(element, input);
        }
        static triggerLabel(element, input) {
            const generatedInput = DOM_1.DOM.Parser.getHtmlElementByClass(Config.inputGeneratedClass, element);
            const label = DOM_1.DOM.Parser.getElementByTag('label', DOM_1.DOM.Parser.getParentElement(element));
            generatedInput.addEventListener('focus', () => { label.classList.add('active'); });
            generatedInput.addEventListener('blur', () => {
                if (input.value.trim().length === 0) {
                    label.classList.remove('active');
                }
            });
            if (input.value.trim().length > 0) {
                label.classList.add('active');
            }
        }
        static triggerClear(element, instance, input) {
            const closeButton = DOM_1.DOM.Parser.getHtmlElementByClass(Config.closeButtonElementClass, element);
            const label = DOM_1.DOM.Parser.getElementByTag('label', DOM_1.DOM.Parser.getParentElement(element));
            closeButton.addEventListener("click", () => {
                instance.clear();
                label.classList.remove('active');
            });
            input.addEventListener('change', () => {
                if (input.value.trim().length === 0) {
                    element.classList.add('empty');
                    label.classList.remove('active');
                }
                else {
                    element.classList.remove('empty');
                    label.classList.add('active');
                }
            });
        }
    }
    ControlsFormDateTimePicker.Control = Control;
})(ControlsFormDateTimePicker || (exports.ControlsFormDateTimePicker = ControlsFormDateTimePicker = {}));
